import { Vehicle } from "../models/Vehicle";

const filterReg = (vehicles: Vehicle[], filter: any) => {
  if (filter === undefined) {
    return vehicles;
  }

  const filtered = vehicles.filter((vehicle: Vehicle) =>
    vehicle?.registration?.toString().includes(`${filter.keyword.toString()}`)
  );

  return filtered;
};

export default filterReg;
